
import { apiGet } from '@/services/BaseApiService';
import api from './api.js';

export const getAttributes = async() => {
    const url = `/getattributes`;
    return apiGet(url);
};

export const logUiError = async (error) => {
   return await api.post('/client-errors', error);
};
